module.exports = __webpack_public_path__ + "static/media/Cloud-wind.0c296814.svg";